
import React from "react";
import { TileContainer } from "@vds/tiles";
import { Icon } from "@vds/icons";
import styled from "styled-components";
import { useMediaQuery } from "react-responsive";
import { Text } from '@vds/core';
import { Line } from "@vds/lines";
import { useTranslation } from "react-i18next";



const StepContainer = ({ handleClick}) => {
    const { t } = useTranslation(["byod"]);
    const isMobile=useMediaQuery({
    query: "(max-device-width: 768px)",
    });

    const isDesktop = useMediaQuery({
        query: "(min-width:769px",
    });
   
    const smallerMobileWidth = useMediaQuery({
        query: "(max-device-width:350px)",
    })
    
  const isTablet=useMediaQuery({ minWidth: 768, maxWidth: 1023 });
  const minDesktop = useMediaQuery({minWidth:0,maxWidth: 768 });

    return (
        <StepWrapper isMobile={isMobile} isTablet={isTablet}  style={{justifyContent:"center", flexDirection: isTablet? "column": "row" ,alignItems:'center',marginTop:smallerMobileWidth && "1.5rem", marginBottom: '12px'}} onClick={handleClick}>
            <TileWrapper
                width={isMobile ?  "296px": isTablet? "87vw": "862px"}
                height={isMobile ? "248px": "112px"}
                padding={isMobile?"": isTablet ? "10px": "24px"}
               >
                <TileContent isMobile={isMobile} isTablet={isTablet} style={{ flexDirection: isMobile  ? "column" : "row",padding: isMobile  ?"16px":"0"}}>
                    <StepContentWrapper>
                    <div><Icon size="XLarge" name="bring-your-own-device" color="#EE0000" />
                       </div>
                        <StepContent>
                             <Text kind="body" size="large" bold>{t("byod.stepContainer.stepOneHeading", { ns: "byod"})}</Text>
                            <StyledDiv isMobile={isMobile} isTablet={isTablet}><Text kind="body" size={`${(isMobile || isTablet) ? "small" : "large"}`}>{t("byod.stepContainer.stepOneContent", { ns: "byod"})}</Text></StyledDiv>
                        </StepContent>
                       
                    </StepContentWrapper>
                    {isDesktop && <BorderStyle />}                
                    {(isMobile ) && <Line style={{ width: isMobile ?  "264px" : "" }} type="secondary" orientation="horizontal" />}
                    <StepContentWrapper>
                    <div><Icon size="XLarge" name="device-protection" color="#EE0000" /></div>
                    <StepContent>
                    <Text kind="body" size="large" bold>{t("byod.stepContainer.stepTwoHeading", { ns: "byod"})}</Text>
                            <StyledDiv isMobile={isMobile} isTablet={isTablet}>
                                <Text kind="body" size={`${(isMobile || isTablet) ? "small" : "large"}`}>{t("byod.stepContainer.stepTwoContent", { ns: "byod"})}</Text>
                            </StyledDiv>
                        </StepContent>
                    </StepContentWrapper>
                    {isDesktop && <BorderStyle />}
                    {(isMobile ) && <Line style={{ width: isMobile ? "264px" : "" }} type="secondary" orientation="horizontal" />}

                    <StepContentWrapper>
                    <div><Icon size="XLarge" name="shopping" color="#EE0000"/></div>
                    <StepContent>
                      <Text kind="body" size="large" bold>{t("byod.stepContainer.stepThreeHeading", { ns: "byod"})}</Text>
                            <StyledDiv isMobile={isMobile} isTablet={isTablet}>
                                <Text kind="body" size={`${(isMobile || isTablet) ? "small" : "large"}`}>{t("byod.stepContainer.stepThreeContent", { ns: "byod" })}</Text>
                            </StyledDiv>
                    </StepContent>
                    </StepContentWrapper>
                </TileContent>
            </TileWrapper>
        
        </StepWrapper>
    )
};


const StepContentWrapper = styled.div`
width:228.67px;
display:flex;
@media only screen and (max-width:768px){
    width:264px;
    height:56px;
}
    @media only screen and (min-width:769px) and (max-width:1023px){
    width:200px;
    height:56px;

}

    
`;

const StepWrapper = styled.div`
top:-1.5rem;
margin-bottom:${({ isMobile, isTablet }) => (isMobile || isTablet ? "4rem": "0")};
position:relative;
display:flex;
@media screen and (min-width: 768px) and (max-width: 1023px){
width:90vw !important;
}
@media screen and (max-width:500px){
top:-1rem;
}

`
const TileContent = styled.div`
display:flex;
gap:1rem;
flexDirection:${({ isMobile, isTablet }) => (isMobile || isTablet ? "column" : "row")};
@media only screen and (min-width:1024px){
gap:2rem;
}
`;

const TileWrapper = styled(TileContainer)`
[class^=InnerTileContainer-VDS]{
    display:flex;
    justify-content:center;
}
`

const StepContent = styled.div`
position:relative;
margin-left:12px;
`;

const StyledDiv = styled.div`
margin-top:0;
width:${({ isMobile, isTablet }) => (isMobile  ? "224px" :isTablet? "150px": "184.67px")}
`;

const BorderStyle = styled.div`
border:1px solid #D8DADA;
transform:rotate(0deg);
`
export default StepContainer;